import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
import { $createParagraphNode, $getRoot, $getSelection, $isRangeSelection } from 'lexical';

import { INSERT_DATA_TABLE_COMMAND } from './InsertDataTableCommand';
import { $createCasDataTableNode, CasTableDataNode, IDataTableConfig } from './CasTableDataNode';

interface Props {
  dataTableConfig?: IDataTableConfig
}

export default function CasTableDataPlugin({ dataTableConfig }: Props) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor.hasNodes([CasTableDataNode])) {
      throw new Error('DataTableNode not registered on editor');
    }
    return editor.registerCommand(
      INSERT_DATA_TABLE_COMMAND,
      () => {
        if(dataTableConfig) {
          editor.update(() => {
          const node = $createCasDataTableNode(dataTableConfig);
          const selection = $getSelection();
          const beforeNode = $createParagraphNode();
          const afterNode = $createParagraphNode();

          if ($isRangeSelection(selection)) {
            // Insert the table node wrapped by two paragraph nodes
            selection.insertNodes([beforeNode, node, afterNode]);

            // Set the selection to the end of the newly inserted content
            afterNode.selectEnd();
          } else {
            const root = $getRoot();
            root.append(beforeNode, node, afterNode);

            afterNode.selectEnd();
          }
        })}
        return true;
      },
      0
    );
  }, [editor, dataTableConfig ]);

  return null;
}
